import LoginForm from 'profile/login/forms/LoginForm';

const ReturningCustomer = (props) => {
  const { slug } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Returning Customer</h4>
      <LoginForm
        redirectLink={`/club/${slug}/signup`}
        forgotPasswordLink={`/club/${slug}/forgot-password`}
        magicLink={`/club/${slug}/magic-link`}
      />
    </div>
  );
};

export default ReturningCustomer;
